<template>
    <div class="grade-bar-container">
        <div class="students-rating grade_item-container">
            <h2 class="grade_item-name">Общий рейтинг обучающихся {{ full ? 'курса' : 'группы' }}. Топ-3</h2>
            <div v-if="loading" class="grade_item-loading-text mt-2">Данные загружаются...</div>
            <RatingList v-if="preview.length > 0" :places="preview" :full="full" />
            <div v-if="preview.length > 0" class="grade_item-btn">
                <v-btn @click="showFullRating" :loading="loading" class="btn">Полный рейтинг</v-btn>
            </div>
            <div v-else-if="noData" class="no-data mt-2">
                Отсутствуют данные
            </div>
            <RatingDialog ref="dialog" :places="places" :full="full" />
        </div>
    </div>
</template>

<script>
import RatingList from './list.vue';
import RatingDialog from './dialog.vue';
import './index.scss';

const PreviewCount = 3;

export default {
    name: 'StudentsRating',
    components: { RatingList, RatingDialog },
    props: {
        full: { type: Boolean, required: false, default: true },
        loading: Boolean
    },
    data: () => ({
        places: [],
        noData: false
    }),
    computed: {
        preview() {
            return this.places.slice(0, PreviewCount);
        }
    },
    methods: {
        update(places) {
            this.places = places;
            this.places.forEach(x => this.$set(x, 'show', false));

            this.noData = this.places.length === 0;
        },
        showFullRating() {
            this.$refs.dialog.open();
        }
    }
}
</script>
